import styled from '@emotion/styled';
import { CollapseArrowSvg } from 'images/shared';

const StyledButton = styled.button(({ theme: { errorColor, primaryColor, fontFamily }, isOpen, hasErrors }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '16px 24px',

  fontFamily: fontFamily,
  fontSize: 16,
  fontWeight: 600,
  color: hasErrors ? errorColor : primaryColor,
  letterSpacing: -0.5,
  lineHeight: '20px',
  textAlign: 'left',
  cursor: 'pointer',
  svg: {
    display: 'block',
    height: '12px',
    width: '20px',
    fill: hasErrors ? errorColor : primaryColor,
    marginLeft: 8,
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 200ms',
  },
}));

const SubTitle = styled.div(({ theme: { highlightColor: color } }) => ({
  color,
  marginTop: 4,
}));

StyledButton.defaultProps = {
  type: 'button',
};

const CollapsableButton = ({ title, subTitle, isOpen, hasErrors, ...props }) => {
  return (
    <StyledButton isOpen={isOpen} hasErrors={hasErrors} {...props}>
      <div>
        {typeof title === 'string' ? (
          <div>{title}</div>
        ) : title}
        {subTitle && <SubTitle style={{ fontSize: 14 }}>{subTitle}</SubTitle>}
      </div>
      <CollapseArrowSvg />
    </StyledButton>
  );
};

export default CollapsableButton;
